<div class="input-checkbox">
  <div
    class="form-check d-flex align-items-center"
    :class="{ 'border-box': border, 'justify-content-center': justifyContentCenter }"
    @click="clickChild"
  >
    <input
      @change="emitChange"
      :class="error ? 'is-invalid': ''"
      v-model="valueInput"
      class="form-check-input"
      type="checkbox"
      :id="id"
      :required="required"
      :disabled="disabled"
    />
    <label class="form-check-label" :for="id" v-if="label" ref="labelForm"> {{ label }} </label>
  </div>
</div>
